import ConnectionStateMonitor from 'src/shared/connection_state_monitor.js'
import Pusher from 'pusher-js'

export default class PusherClient {
  static connection () {
    if (this.client) { return this.client }

    this.client = this.pusherClient()

    return this.client
  }

  static pusherClient () {
    const pusher = new Pusher(window.gon.pusher_key, window.gon.pusher_config)

    pusher.connection.bind('state_change', states => ConnectionStateMonitor.onChange(states))

    return pusher
  }
}
